import { VStack } from '@cad-arc';
import { ReactElement } from 'react';
import { TabMode } from './types';

export function TabsWrapper(props: { mode: TabMode; children: ReactElement }) {
    const commonProps = {
        spacing: 0,
        bg: 'surface.canvas',
        width: '100%',
    };

    return props.mode === 'FULL' ? (
        <VStack
            {...commonProps}
            h="100%"
            borderLeft="sm"
            borderColor="border.default"
            justifyContent="end"
        >
            {props.children}
        </VStack>
    ) : (
        <VStack {...commonProps} alignItems="stretch" position="sticky" bottom={0} zIndex={5}>
            {props.children}
        </VStack>
    );
}
